import { render, staticRenderFns } from "./AnnounceColor.vue?vue&type=template&id=6c4c6f53&"
import script from "./AnnounceColor.vue?vue&type=script&lang=js&"
export * from "./AnnounceColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports